module.exports = __webpack_public_path__ + "img/emoji_99.a5b07a56.png";